define.alias("shared/utils/formatters/ig-user-from-basic-display", "calendar/utils/formatters/ig-user-from-basic-display");